import { Component, inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Group } from "./group";
import { DragAndDropDialogData } from "../dialog/dragAndDropDialog.component";

export interface DragAndDropGroupDialogData<T extends object = Record<string, unknown>>
    extends DragAndDropDialogData<T>
{
    readonly groupProperty: keyof T;
    readonly sequenceProperty: keyof T;
}

@Component({
    selector: "drag-and-drop-group-dialog-component",
    templateUrl: "./dragAndDropGroupDialog.tmpl.html",
    styleUrls: [
        "./dragAndDropGroupDialog.component.scss"
    ],
    standalone: false
})
export class DragAndDropGroupDialogComponent<T extends object = Record<string, unknown>>
{
    private readonly dialogRef = inject<MatDialogRef<DragAndDropGroupDialogComponent, Array<Group<T>>>>(MatDialogRef);
    private readonly data = inject<DragAndDropGroupDialogData<T>>(MAT_DIALOG_DATA);

    splitGroups: Array<Group<T>> = [];

    get groups(): Array<Array<T>> { return this.data.groups; }
    get display(): string { return this.data.display?.toString(); }
    get subtitleMember(): keyof T { return this.data.subtitleMember; }
    get dialogTitle(): string { return this.data.dialogTitle; }
    get dialogSubtitle(): string { return this.data.dialogSubtitle; }
    get groupProperty(): keyof T { return this.data.groupProperty; }
    get sequenceProperty(): keyof T { return this.data.sequenceProperty; }

    get message(): string
    {
        const leftRightClause = this.groups.length > 1
            ? " or left and right"
            : "";
        return `Drag and drop ${this.dialogSubtitle} up and down${leftRightClause} to rearrange.`;
    }

    add(): void
    {
        this.dialogRef.close(this.splitGroups);
    }

    close(): void
    {
        this.dialogRef.close();
    }
}
